import {StyledMenu, StyledMenuGroup, StyledMenuItem, StyledMenuHeading} from '@components/ui/menu-atoms/style.ts'
import {MenuProps, MenuGroupProps, MenuItemProps, MenuHeadingProps} from '@ariakit/react'
import {CSSProperties, FC, forwardRef} from 'react'

export const Menu: FC<MenuProps & {width?: CSSProperties['width']}> = ({width, portal = true, ...rest}) => (
    <StyledMenu portal={portal} gutter={8} unmountOnHide $width={width} {...rest} />
)
export const MenuHeading = (props: MenuHeadingProps) => <StyledMenuHeading {...props} />
export const MenuGroup = (props: MenuGroupProps) => <StyledMenuGroup {...props} />

export type MenuVariant = 'neutral' | 'danger'
export const MenuItem = forwardRef<HTMLDivElement, MenuItemProps & {variant?: MenuVariant}>(
    ({variant = 'neutral', ...props}, ref) => <StyledMenuItem ref={ref} {...props} $variant={variant} />
)
